<template>
  <b-form-group
    label="Kategori"
    label-for="id_service_categories"
  >
    <validation-provider
      #default="{ errors }"
      name="Kategori"
      rules="required"
    >
      <v-select
        id="id_service_categories"
        v-model="dataItem.id_service_categories"
        :options="dataList"
        label="title"
        :reduce="item => item.id"
        placeholder="Kategori"
      >
        <template v-slot:option="option">
          <div>
            {{ option.title }}
          </div>

        </template>
      </v-select>
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup,
} from 'bootstrap-vue'
import { required } from '@validations'
import vSelect from 'vue-select'

export default {
  name: 'ServiceCategory',
  components: {
    BFormGroup,
    vSelect,
    ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataList() {
      return this.$store.getters['serviceCategories/dataList']
    },
    dataItem() {
      return this.$store.getters['services/dataItem']
    },
  },
  created() {
    localize('tr')
    this.getDataList()
  },
  methods: {
    getDataList() {
      this.$store.dispatch('serviceCategories/getDataList', {
        select: [
          'service_categories.id AS id',
          'service_categories.title AS title',
        ],
      })
    },
  },
}
</script>
